import "./App.css";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { persistor, store } from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { axiosConfig } from "./axios";
import UserHome from "./components/userHome";
import { lazy, useEffect } from "react";

const LegalVisitor = lazy(() => import("./components/legalVisitor"));
const RegisterVisitor = lazy(() =>
  import("./eventManagement/components/registerVisitor.js")
);
const VisitorInfo = lazy(() =>
  import("./eventManagement/components/visitorInfo")
);

function App() {
  useEffect(() => {
    axiosConfig();
  });
  return (
    <Provider store={store}>
      <Router>
        <PersistGate persistor={persistor}>
          <Switch>
            <Route exact path="/legalVisitor" component={LegalVisitor} />
            <Route exact path="/registerVisitor" component={RegisterVisitor} />
            <Route exact path="/visitorInfo" component={VisitorInfo} />
            <Route
              exact
              path={[
                "/userHome/:parkingZone",
                "/userHome",
                "/userHome/:parkingZone/:code",
              ]}
              component={UserHome}
            />
            <Route path="/registerVisitor/:invitationId" component={RegisterVisitor} />
            <Redirect to="/userHome" />
          </Switch>
        </PersistGate>
      </Router>
    </Provider>
  );
}

export default App;
